import React from 'react';
import ComboBox from 'Components/ComboBox/ComboBox';
import InputField from 'Components/Input/InputField';
import ReactDatePicker from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import { parseISO } from 'date-fns';
import TextAreaField from 'Components/TextAreaField/TextAreaField';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';

function AutomaticallyListedAttributesGrid(
    {
        row,
        rowsBackend,
        setRowsBackend,
        updateHelperOperationList,
        localStorageName,
        attributeList,
        executeAfterSave,
        rowIndex,
        dsOperation
    }
) {

    if (!row.id) {
        return null;
    }

    return (
        <div className="user-row">
            {
                row.constructorList.map((attribute, index) => {
                    const attributeDataBackend = {
                        id: row.id,
                        field: attribute.field,
                        labelGrid: attribute.labelGrid,
                        value: attribute.argument,
                        columnType: attribute.columnType,
                        readOnly: attribute.readOnly,
                        isVisible: attribute.visible == 'N' ? false : true,
                        mask: attribute.mask,
                        placeholder: attribute.placeHolder,
                        checked: attribute.checked,
                        attributesChange: attribute.attributesChange
                    };

                    if (!attributeDataBackend.labelGrid) {
                        return null;
                    }

                    const attributeDataFrontend = attributeList.find(obj => obj.name === attributeDataBackend.field) || {};
                    const readOnlyField = getReadOnlyField(attributeDataFrontend.readOnly, attributeDataBackend.readOnly);

                    const inputField = getComponentFieldEditable(
                        attributeDataBackend,
                        rowsBackend,
                        setRowsBackend,
                        updateHelperOperationList,
                        localStorageName,
                        attributeDataFrontend,
                        readOnlyField,
                        executeAfterSave,
                        rowIndex,
                        dsOperation
                    );

                    const visible =
                        attributeDataFrontend?.isVisible === false || attributeDataFrontend?.isVisible == 'N'
                            ? false
                            : attributeDataBackend?.isVisible === false || attributeDataBackend?.isVisible == 'N'
                                ? false
                                : true;


                    if (inputField && visible) {
                        return (
                            <div
                                key={index}
                                className="cell no-padding"
                                style={{
                                    minWidth: attributeDataFrontend.minGridWidth || '100%',
                                    maxWidth: attributeDataFrontend.maxGridWidth || '250px',
                                    cursor: attributeDataFrontend.cursor || 'default',
                                    whiteSpace: attributeDataFrontend.whiteSpace || 'nowrap',
                                    backgroundColor: styleRowPanelList(rowIndex)
                                }}
                            >
                                <div style={{ display: 'flex', height: '100%' }}>
                                    {inputField}
                                </div>
                            </div>
                        );
                    }

                    return null;
                })
            }
        </div>
    );
}

function styleRowPanelList(index) {
    return index % 2 === 0 ? 'rgb(248 248 248)' : 'white';
}

function getReadOnlyField(readOnlyFrontend, readOnlyBackend) {
    if (readOnlyFrontend) {
        return true;
    } else if (readOnlyBackend === 'S') {
        return true;
    }
    return false;
}

function updateFieldValue(rowsBackend, id, field, newValue, attributeDataFrontend) {
    return rowsBackend.map(row => {
        if (row.id === id) {
            const updatedRow = {
                ...row,
                constructorList: row.constructorList.map(attribute => {
                    // Atualiza o campo original (campo x)
                    if (attribute.field === field) {
                        const updatedAttribute = attribute.columnType.toUpperCase() === 'CHECKBOX'
                            ? { ...attribute, checked: newValue }
                            : { ...attribute, argument: newValue };

                        // Copiar valor para outros campos definidos (como campo y)
                        if (attributeDataFrontend.copyValueToFields?.length > 0) {
                            attributeDataFrontend.copyValueToFields.forEach(copyFieldName => {
                                const targetAttr = row.constructorList.find(a => a.field === copyFieldName);
                                if (targetAttr) {
                                    if (targetAttr.columnType.toUpperCase() === 'CHECKBOX') {
                                        targetAttr.checked = newValue;
                                    } else {
                                        targetAttr.argument = newValue;
                                    }
                                }
                            });
                        }

                        // Lógica de alterações condicionais
                        if (attributeDataFrontend.attributesChange) {
                            attributeDataFrontend.attributesChange.forEach(change => {
                                const allConditionsMet = change.condition.every(condition => {
                                    return (
                                        (updatedAttribute.field.toUpperCase() === condition.name.toUpperCase() &&
                                            ((updatedAttribute.columnType.toUpperCase() === 'CHECKBOX' && updatedAttribute.checked === condition.value) ||
                                                updatedAttribute.argument === condition.value)) ||
                                        (updatedAttribute.field.toUpperCase() !== condition.name.toUpperCase() &&
                                            row.constructorList.some(attr =>
                                                attr.field.toUpperCase() === condition.name.toUpperCase() &&
                                                ((attr.columnType.toUpperCase() === 'CHECKBOX' && attr.checked === condition.value) ||
                                                    attr.argument === condition.value)
                                            ))
                                    );
                                });

                                if (allConditionsMet) {
                                    row.constructorList.forEach(attr => {
                                        if (attr.field.toUpperCase() === change.name.toUpperCase()) {
                                            if (attr.columnType.toUpperCase() === 'CHECKBOX') {
                                                attr.checked = change.getterNewValue;
                                            } else {
                                                attr.argument = change.getterNewValue;
                                            }
                                            change.setterAfterGetter();
                                        }
                                    });
                                }
                            });
                        }

                        return updatedAttribute;
                    }

                    return attribute;
                })
            };

            return updatedRow;
        }
        return row;
    });
}

function handleUpdateField(attributeDataBackend, newValue, rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, executeAfterSave, dsOperation) {
    const updatedRows = updateFieldValue(rowsBackend, attributeDataBackend.id, attributeDataBackend.field, newValue, attributeDataFrontend);
    const updatedRow = updatedRows.find(row => row.id === attributeDataBackend.id);
    updateRowInLocalStorage(localStorageName, updatedRow, setRowsBackend, updateHelperOperationList, dsOperation);

    if (executeAfterSave) {
        executeAfterSave();
    }
}

function updateRowInLocalStorage(localStorageName, updatedRow, setRowsBackend, updateHelperOperationList, dsOperation) {
    const currentData = getFromLocalStorage(localStorageName);

    const newData = currentData.map(row =>
        row.id === updatedRow.id ? updatedRow : row
    );

    localStorage.setItem(localStorageName, JSON.stringify(newData));
    if (updateHelperOperationList) {
        updateHelperOperationList(newData);
    }

    if (!dsOperation || dsOperation.trim() === '') {
        setRowsBackend(newData);
    } else {
        const filtered = newData.filter(op => {
            const attr = op.constructorList.find(attr => attr.field === 'dsOperation');
            return attr?.argument?.toLowerCase().includes(dsOperation.toLowerCase());
        });
        setRowsBackend(filtered);
    }
}


function saveToLocalStorage(
    localStorageName,
    setRowsBackend,
    updateHelperOperationList,
    rowsBackend
) {
    localStorage.setItem(localStorageName, JSON.stringify(rowsBackend));
    setRowsBackend(rowsBackend);

    if (updateHelperOperationList) {
        updateHelperOperationList(rowsBackend);
    }
}

function getComponentFieldEditable(attributeDataBackend, rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, readOnlyField, executeAfterSave, index, dsOperation) {
    const mainAttributesStyle = {
        borderRadius: '0px',
        width: attributeDataFrontend.width
    }

    switch (attributeDataBackend.columnType) {
        case 'input':
            return (
                <InputField
                    setAttribute={(value) => handleUpdateField(attributeDataBackend, value, rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, executeAfterSave, dsOperation)}
                    value={attributeDataBackend.value}
                    readOnly={readOnlyField}
                    disabled={readOnlyField}
                    style={{ ...attributeDataFrontend.style, ...mainAttributesStyle, cursor: attributeDataFrontend.cursor, backgroundColor: styleRowPanelList(index) }}
                    mask={attributeDataFrontend.mask || attributeDataBackend.mask}
                    decimalScale={attributeDataFrontend.decimalScale}
                />
            );
        case 'combobox':
            return (
                <ComboBox
                    setAttribute={(value) => handleUpdateField(attributeDataBackend, value, rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, executeAfterSave, dsOperation)}
                    optionsData={attributeDataFrontend.comboboxOptions}
                    value={attributeDataBackend.value}
                    style={{ ...attributeDataFrontend.style, ...mainAttributesStyle, backgroundColor: styleRowPanelList(index) }}
                    defaultValue={attributeDataFrontend.style}
                    readOnly={readOnlyField}
                    disabled={readOnlyField}
                />
            );
        case 'checkbox':
            return (
                <InputField
                    setAttribute={(value) => handleUpdateField(attributeDataBackend, attributeDataBackend.checked === 'S' ? 'N' : 'S', rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, executeAfterSave, dsOperation)}
                    value={attributeDataBackend.value ? attributeDataBackend.value : 'N'}
                    checked={attributeDataBackend.checked ? attributeDataBackend.checked === 'S' : false}
                    readOnly={readOnlyField}
                    disabled={readOnlyField}
                    type="checkbox"
                    style={{ ...attributeDataFrontend.style, cursor: 'pointer', ...mainAttributesStyle, backgroundColor: styleRowPanelList(index) }}
                />
            );
        case 'text-area':
            return (
                <TextAreaField
                    setAttribute={(value) => handleUpdateField(attributeDataBackend, value, rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, executeAfterSave, dsOperation)}
                    value={attributeDataBackend.value}
                    type="text"
                    readOnly={readOnlyField}
                    disabled={readOnlyField}
                    style={{ ...attributeDataFrontend.style, ...mainAttributesStyle, backgroundColor: styleRowPanelList(index) }}
                />
            );
        case 'date':
            let selectedDate = attributeDataBackend.value;
            if (typeof selectedDate === 'string' && selectedDate) {
                selectedDate = parseISO(selectedDate);
            }

            return (
                <ReactDataPickerComp
                    selected={selectedDate}
                    onChange={(date) => handleUpdateField(attributeDataBackend, date, rowsBackend, setRowsBackend, updateHelperOperationList, localStorageName, attributeDataFrontend, executeAfterSave, dsOperation)}
                    className='cost-fix-width-date cursor-pointer'
                    showMonthYearPicker={attributeDataBackend.mask.toUpperCase() === 'MM/YYYY'}
                    timeFormat={attributeDataBackend.mask.toUpperCase()}
                    placeholderText={attributeDataBackend.placeholder}
                    dateFormat={attributeDataBackend.mask}
                    style={{ ...attributeDataFrontend.style, ...mainAttributesStyle, backgroundColor: styleRowPanelList(index) }}
                    locale={ptBR}
                    readOnly={readOnlyField}
                    disabled={readOnlyField}
                />
            );
        default:
            return null;
    }
}

function clearLocalStorage(localStorageName) {
    localStorage.removeItem(localStorageName);
}

function getFromLocalStorage(localStorageName) {
    const storedData = localStorage.getItem(localStorageName);
    return storedData ? JSON.parse(storedData) : [];
}

export { AutomaticallyListedAttributesGrid, getFromLocalStorage, saveToLocalStorage, clearLocalStorage };
